<div class="loader" [class.loader--full-size]="fullSize">
  <div class="loader__panel" role="status" aria-live="polite">
    <span class="company-loader__sr-only">Loading</span>
    <div class="company-loader__spinner" aria-hidden="true"></div>
  </div>
</div>
